var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 9.5C6.75 9.18934 7.00184 8.9375 7.3125 8.9375H15.1875C15.4982 8.9375 15.75 9.18934 15.75 9.5C15.75 9.81066 15.4982 10.0625 15.1875 10.0625H7.3125C7.00184 10.0625 6.75 9.81066 6.75 9.5Z",
    fill: "#1B2436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 5C6.75 4.68934 7.00184 4.4375 7.3125 4.4375H15.1875C15.4982 4.4375 15.75 4.68934 15.75 5C15.75 5.31066 15.4982 5.5625 15.1875 5.5625H7.3125C7.00184 5.5625 6.75 5.31066 6.75 5Z",
    fill: "#1B2436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 14C6.75 13.6893 7.00184 13.4375 7.3125 13.4375H15.1875C15.4982 13.4375 15.75 13.6893 15.75 14C15.75 14.3107 15.4982 14.5625 15.1875 14.5625H7.3125C7.00184 14.5625 6.75 14.3107 6.75 14Z",
    fill: "#1B2436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23335 3.67776C4.39918 3.78025 4.50012 3.9613 4.50012 4.15625V8.09375C4.50012 8.40441 4.24828 8.65625 3.93762 8.65625C3.62696 8.65625 3.37512 8.40441 3.37512 8.09375V5.06639L3.06418 5.22187C2.78632 5.3608 2.44844 5.24817 2.30951 4.97031C2.17058 4.69245 2.2832 4.35457 2.56107 4.21564L3.68607 3.65314C3.86043 3.56595 4.06751 3.57527 4.23335 3.67776Z",
    fill: "#1B2436"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83374 11.1775C3.77459 11.1731 3.71517 11.1813 3.65937 11.2014C3.60357 11.2216 3.55265 11.2533 3.50992 11.2944C3.4672 11.3356 3.43363 11.3853 3.41142 11.4403C3.29509 11.7283 2.96726 11.8675 2.67921 11.7512C2.39115 11.6349 2.25194 11.3071 2.36827 11.019C2.44973 10.8173 2.5728 10.6351 2.72945 10.4842C2.88611 10.3333 3.07283 10.2171 3.27742 10.1433C3.48201 10.0694 3.69988 10.0395 3.9168 10.0556C4.13372 10.0717 4.34482 10.1333 4.5363 10.2365C4.72779 10.3396 4.89537 10.482 5.0281 10.6543C5.16082 10.8267 5.25572 11.025 5.30658 11.2365C5.35745 11.448 5.36314 11.6678 5.32329 11.8817C5.28344 12.0955 5.19894 12.2985 5.07531 12.4775C5.07125 12.4833 5.06709 12.4891 5.06282 12.4948L3.93619 13.9999H4.78125C5.09191 13.9999 5.34375 14.2518 5.34375 14.5624C5.34375 14.8731 5.09191 15.1249 4.78125 15.1249H2.8125C2.59954 15.1249 2.40484 15.0047 2.30951 14.8142C2.21418 14.6238 2.23457 14.3959 2.36219 14.2254L4.15444 11.831C4.18558 11.784 4.20698 11.7311 4.21733 11.6755C4.2282 11.6172 4.22665 11.5573 4.21278 11.4996C4.1989 11.4419 4.17302 11.3878 4.13683 11.3408C4.10063 11.2938 4.05492 11.255 4.0027 11.2269C3.95047 11.1987 3.8929 11.1819 3.83374 11.1775Z",
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.ad5a6e68c857565d3195cac478115451.svg";
export { ForwardRef as ReactComponent };